import React from "react";

import "./AppLogo.css";

export default function AppLogo() {
  return (
    <div className="col appLogo">
      <i className="fas fa-poo-storm" />
      <div className="appTitle">WeatherApp</div>
    </div>
  );
}
